import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=12e8e3b9&scoped=true&"
import script from "./Message.js?vue&type=script&lang=js&"
export * from "./Message.js?vue&type=script&lang=js&"
import style0 from "./Message.scss?vue&type=style&index=0&id=12e8e3b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8e3b9",
  null
  
)

export default component.exports